import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { TicketService } from "../../ticket.service";
import { ICurrentUser } from "app/auth/models/user-interface";
import { ITicket } from "../../models/tickets";

@Component({
  selector: "app-support-request-assigned-to-me",
  templateUrl: "./support-request-assigned-to-me.component.html",
  styleUrls: ["./support-request-assigned-to-me.component.scss"],
})
export class SupportRequestAssignedToMeComponent implements OnInit {
  public ticket_list: ITicket[] = [];
  public arrayLength: number = 0;
  public me: ICurrentUser;

  constructor(
    public _ticketService: TicketService,
    public _utilsService: UtilsService,
    public _authenticationService: AuthenticationService,
  ) {
    this.me = this._authenticationService.getCurrentUser();
  }

  async ngOnInit() {
    this.ticket_list = await this._ticketService.getList();
    // Filtro i ticket per quelli che non sono ancora completati, prendo quelli che non hanno un operatore, e quelli presi in carica dal dipendente
    this.ticket_list = this.ticket_list
      .filter((ticket: ITicket) => ticket.last_step.status !== 2 && !!ticket.last_step.operator && (ticket.last_step.operator.hash === null || ticket.last_step.operator.hash === this.me.hash))
      .sort((a: ITicket, b: ITicket) => b.last_step.status - a.last_step.status);
    this.arrayLength = this.ticket_list.length - 5;
    this.ticket_list = this.ticket_list.slice(0, 5);
    const completed: string = await this._utilsService.translate("COMPLETED");
    const pending: string = await this._utilsService.translate("PENDING");
    const takenCharge: string = await this._utilsService.translate("TAKEN_CHARGE");
    this.ticket_list.map((item: ITicket) => {
      if (item.last_step.status === 1) {
        item.enabled_label = takenCharge;
      } else if (item.last_step.status === 2) {
        item.enabled_label = completed;
      } else {
        item.enabled_label = pending;
      }
    });
  }
}
